
import { defineComponent } from "vue";
import { roundDecimal } from "@/helper/util";
import Countdown from "@/data/Countdown";

export default defineComponent({
  name: "CountdownBar",

  props: {
    countdown: {
      type: Countdown,
      required: true,
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    colorClass() {
      if (!this.countdown.isRunning) {
        return "";
      }
      let ratio =
        this.countdown.max > 0
          ? this.countdown.exactValue / this.countdown.max
          : 0;
      if (ratio >= 0.15) {
        return "background--green";
      } else if (ratio <= 0.05) {
        return "background--red";
      } else {
        return "background--orange";
      }
    },
    barWidthStyle() {
      let ratio =
        this.countdown.max > 0
          ? (this.countdown.exactValue / this.countdown.max) * 100
          : 100;
      ratio = roundDecimal(ratio, 2);
      return `width: ${100 - ratio}%`;
    },
    roundedCurrent() {
      return Math.ceil(this.countdown.exactValue);
    },
    countdownText() {
      return this.countdown.exactValue <= 0 ? "" : this.roundedCurrent;
    },
  },
});
